import React from "react";
import { Box, Typography, createStyles, withStyles } from "@material-ui/core";
import { magicLinkColors, magicLinkRadius } from "./magicLinkTokens";

interface Props {
  title: string;
  description: string;
  action: React.ReactNode;
  classes: Record<string, string>;
}

const styles = (theme: any) =>
  createStyles({
    card: {
      display: "flex",
      flexDirection: "column",
      gap: 12,
      padding: 24,
      boxSizing: "border-box",
      borderRadius: magicLinkRadius.card,
      backgroundColor: magicLinkColors.surface,
    },
    top: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: 12,
    },
    title: {
      fontFamily: "Nunito Sans",
      fontSize: "19px",
      fontWeight: 600,
      lineHeight: "26px",
      color: magicLinkColors.textStrong,
    },
    line: {
      height: 1,
      backgroundColor: theme.palette.primary.main,
    },
    description: {
      fontFamily: "Nunito Sans",
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "20px",
      color: magicLinkColors.text,
    },
  });

const ActionCard = ({ title, description, action, classes }: Props) => (
  <Box className={classes.card}>
    <Box className={classes.top}>
      <Typography component="h2" className={classes.title}>
        {title}
      </Typography>
      {action}
    </Box>
    <Box className={classes.line} />
    <Typography className={classes.description}>{description}</Typography>
  </Box>
);

export default withStyles(styles)(ActionCard);
